<div class="message-container" [ngClass]="{ 'no-message': noMessage }">
  <div *ngIf="icon" class="message-icon">
    <fa-icon [icon]="iconValue" size="2x" [spin]="loading"></fa-icon>
  </div>
  <div class="message-content">
    {{ messageText | translate }}
  </div>
  <div *ngIf="messageActions" class="message-actions p-actions-bar">
    <ng-container *ngTemplateOutlet="messageActions"></ng-container>
  </div>
</div>
